import AdicionalGrupoService from "@/services/AdicionalGrupoService";

export const adicionalGrupo = {
  namespaced: true,
  state: {
    adicionalGrupo: {},
  },
  actions: {
    getAdicionalGrupo({ commit }, payload) {
      return AdicionalGrupoService.GetAdicionalGrupo(payload).then(
        (adicionalGrupo) => {
          return Promise.resolve(adicionalGrupo);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postAdicionalGrupo({ commit }, payload) {
      return AdicionalGrupoService.PostAdicionalGrupo(payload).then(
        (adicionalGrupo) => {
          return Promise.resolve(adicionalGrupo);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putAdicionalGrupo({ commit }, payload) {
      return AdicionalGrupoService.PutAdicionalGrupo(payload).then(
        (adicionalGrupo) => {
          return Promise.resolve(adicionalGrupo);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteAdicionalGrupo({ commit }, payload) {
      return AdicionalGrupoService.DeleteAdicionalGrupo(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getAdicionalGrupoOData({ commit }, payload) {
      return AdicionalGrupoService.GetAdicionalGrupoOData(payload).then(
        (adicionalGrupo) => {
          return Promise.resolve(adicionalGrupo);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default adicionalGrupo;
